import React from 'react'
import { PartnerDashboardComponent} from "../components";

export const PartnerDashboardPage: React.FC = () => <PartnerDashboardComponent/>;
